(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  function init() {
    const header = document.querySelector('[data-editorial-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';



    const menus = Array.from(header.querySelectorAll('.desktop-nav > .osa-help'));
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controllers = new Map();
    menus.forEach(menu => {
      let timer, animation;
      const summary = menu.querySelector('summary');
      const panel = menu.querySelector('.osa-help-panel');
      const reset = () => { clearTimeout(timer); if (animation) { animation.cancel(); animation = null; } };
      const close = (immediate = false) => {
        clearTimeout(timer);
        if (!menu.open) return;
        reset();
        if (immediate || reducedMotion.matches) { menu.open = false; panel.style.pointerEvents = ''; return; }
        panel.style.pointerEvents = 'none';
        animation = panel.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-6px)'}],{duration:240,easing:'ease-in',fill:'forwards'});
        const current = animation;
        current.onfinish = () => { if (animation !== current) return; menu.open = false; reset(); panel.style.pointerEvents = ''; };
      };
      const open = () => {
        clearTimeout(timer);
        if (menu.open && panel.style.pointerEvents !== 'none') return;
        reset();
        controllers.forEach((controller, other) => { if (other !== menu) controller.close(true); });
        menu.open = true; panel.style.pointerEvents = '';
        if (!reducedMotion.matches) {
          animation = panel.animate([{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'cubic-bezier(.22,1,.36,1)'});
          const current = animation;
          current.onfinish = () => { if (animation === current) animation = null; };
        }
      };
      controllers.set(menu, {close, open});
      menu.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') open(); });
      menu.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') timer = setTimeout(() => close(), 120); });
      summary.addEventListener('click', event => {
        event.preventDefault();
        if (finePointer.matches && event.detail > 0) return;
        if (menu.open) close(); else open();
      });
      menu.addEventListener('focusout', () => { setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) close(); }, 0); });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { summary.focus(); close(true); } });
    });
    document.addEventListener('pointerdown', event => { controllers.forEach((controller, menu) => { if (!menu.contains(event.target)) controller.close(); }); });
    header.querySelectorAll('[data-osa-localization]').forEach(select => { select.addEventListener('change', () => select.form.requestSubmit()); });
    let ticking = false;
    const update = () => {
      header.parentElement.style.setProperty('--osa-overlay-height', `${header.offsetHeight}px`);
      header.toggleAttribute('data-scrolled', window.scrollY > 1);
      header.style.setProperty('--osa-menu-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      ticking = false;
    };
    const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    new ResizeObserver(schedule).observe(header);
    update();
  }
  init(); document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
